import { createSlice } from '@reduxjs/toolkit';

// // Login Slice
// const loginSlice = createSlice({
//   name: 'login',
//   initialState: { login: false },
//   reducers: {
//     setLogin: (state, action) => {
//       state.login = action.payload;
//     },
//   },
// });

// // Export the actions
// export const { setLogin } = loginSlice.actions;

// export const loginReducer = loginSlice.reducer;

// Token Slice
export const tokenSlice = createSlice({
    name: 'token',
    initialState:{ token: '' },
    reducers: {
      setToken: (state, action) => {
        state.token = action.payload;
      },
      clearToken: (state) => {
        state.token = null;
      },
    },
  });

  // Export actions
  export const { setToken, clearToken } = tokenSlice.actions;
  export const tokenReducer = tokenSlice.reducer;

// User Data Slice
const userDataSlice = createSlice({
    name: 'user',
    initialState: {user:{}},
    reducers: {
      setUser: (state, action) => {
        state.user = action.payload;
      },
    },
  });
  
  // Export the actions
  export const { setUser } = userDataSlice.actions;
  
  export const userDataReducer = userDataSlice.reducer;

  
  // Mandate ID Slice
const mandateIdSlice = createSlice({
    name: 'mandate',
    initialState: {mandate:''},
    reducers: {
      setMandate: (state, action) => {
        state.mandate = action.payload;
      },
    },
  });
  
  // Export the actions
  export const { setMandate } = mandateIdSlice.actions;
  
  export const mandateIdReducer = mandateIdSlice.reducer;

  
  // LAN ID Slice
const lanIdSlice = createSlice({
    name: 'lan',
    initialState: {lan:''} ,
    reducers: {
      setLan: (state, action) => {
        state.lan = action.payload;
      },

    },
  });

  // Export the actions
  export const { setLan } = lanIdSlice.actions;
  
  export const lanIdReducer = lanIdSlice.reducer;

  const phoneNumberSlice = createSlice({
    name: 'phone',
    initialState: {phone:0},
    reducers: {
      setPhone: (state, action) => {
        state.phone = action.payload;
      },
    },
  });
  
export const { setPhone } = phoneNumberSlice.actions;

export const phoneNumberReducer = phoneNumberSlice.reducer;

const dateSlice = createSlice({
  name: 'date',
  initialState: {date:''},
  reducers: {
    setDate: (state, action) => {
      state.date = action.payload;
    },
  },
});

export const { setDate } = dateSlice.actions;

export const dateReducer = dateSlice.reducer;


const umrnSlice = createSlice({
  name: 'umrn',
  initialState: {umrn:''},
  reducers: {
    setUmrn: (state, action) => {
      state.umrn = action.payload;
    },
  },
});

export const { setUmrn } = umrnSlice.actions;

export const umrnReducer = umrnSlice.reducer;


const dcMandateIdSlice = createSlice({
  name: 'dcMandate',
  initialState: {dcMandate:''},
  reducers: {
    setDcMandate: (state, action) => {
      state.dcMandate = action.payload;
    },
  },
});

export const { setDcMandate } = dcMandateIdSlice.actions;

export const dcMandateReducer = dcMandateIdSlice.reducer;

const softpullDataSlice = createSlice({
  name: 'softpullData',
  initialState: {
    softpullData: {
      appId: '',
      consumerId: '',
      phoneNumber: '',
    },
  },
  reducers: {
    setSoftpullData: (state, action) => {
      state.softpullData = action.payload;
    },
  },
});

export const { setSoftpullData } = softpullDataSlice.actions;

export const softpullDataReducer = softpullDataSlice.reducer;
